<template>
  <div class="ws-data-expand-list">
    <div v-if="searchMode" class="search-section">
      <WsSearchInput
        @submit="$_onSearchSubmit()"
        v-model="searching"
        :placeholder="`搜尋${label}`"
      ></WsSearchInput>
      <WsBtn @click="$_onSearchSubmit()">搜尋</WsBtn>
    </div>
    <WsCard v-if="createModeActive && !groupSaving">
      <ValidationObserver ref="form">
        <WsStateForm
          :generalFields="_updateFields"
          @isCompleted="$_isFormCompleted($event, value)"
          :modelData="modelData"
          :value="createData"
          :customParentData="customParentData"
          :updateData="_updateData"
          @input="$_onInput($event)"
        ></WsStateForm>
      </ValidationObserver>
      <v-divider></v-divider>
      <v-card-actions class="pa-5">
        <v-spacer></v-spacer>
        <WsBtn @click="$_onCreateCancel()" minWidth="100px" color="textSecondary" outlined
          >取消</WsBtn
        >
        <WsBtn
          @click="$_onCreateSubmit()"
          minWidth="100px"
          :loading="createSubmitLoading"
          color="primary"
          >儲存</WsBtn
        >
      </v-card-actions>
    </WsCard>
    <div v-else class="ws-button-group">
      <WsBtn v-if="hasChapters" :to="_editPath" color="primary" outlined block>
        <v-icon left>mdi-plus</v-icon> 編輯當前版本題目
      </WsBtn>
      <WsBtn v-else-if="tabSetting" @click="$_multiSelectOpen()" color="primary" outlined block>
        <v-icon left>mdi-plus</v-icon> 新增{{ tabActiveName }}
      </WsBtn>
      <WsBtn
        v-else-if="itemCreateBtnEmitAble"
        @click="$_createBtnClickEmit()"
        color="primary"
        outlined
      >
        <v-icon left>mdi-plus</v-icon> 新增{{ label }}
      </WsBtn>
      <WsBtn
        v-else-if="!hasCatchVersion && !groupSaving && itemCreatable"
        @click="$_createOpen()"
        color="primary"
        outlined
      >
        <v-icon left>mdi-plus</v-icon> 單筆新增{{ label }}
      </WsBtn>
      <WsBtn v-show="batchMode" :to="`${_batchLink}?redirect=${$route.fullPath}`" color="primary"
        >批次新增</WsBtn
      >
      <WsBtn
        v-show="isBatchCreateMultiLangAble"
        :to="`${_batchCreateMultiLangLink}?redirect=${$route.fullPath}`"
        color="primary"
        >建立多語系</WsBtn
      >
    </div>
    <div class="ws-data-expand-list__content" ref="infiniteList">
      <div v-if="hasChapters">
        <div v-for="(chapterItem, chapterIndex) in _sequenceFields" :key="chapterIndex">
          <div class="ws-data-expand-list__chapters">
            第{{ chapterIndex + 1 }}章 {{ chapterItem.chapterTitle }}
          </div>
          <div v-for="(sectionItem, sectionIndex) in chapterItem.sections" :key="sectionIndex">
            <div class="ws-data-expand-list__sections">
              第{{ chapterIndex + 1 }}-{{ sectionIndex + 1 }}節 {{ sectionItem.sectionTitle }}
            </div>

            <div class="ws-data-expand-list__topics">
              <WsDataExpandListItem
                v-for="(topicItem, topicIndex) in sectionItem.topics"
                :key="topicIndex"
                :modelName="modelName"
                :titleKey="titleKey"
                :modeVersions="modeVersions"
                :value="topicItem"
                :modelId="topicItem.id"
                :fields="fields"
                :fieldsRead="fieldsRead"
                :locale="locale"
                :hideOnNull="hideOnNull"
                :parentModelName="parentModelName"
                :createVersion="createVersion"
                :itemVersionCreatable="itemVersionCreatable"
                :itemVersionLinkCreatable="itemVersionLinkCreatable"
                :itemVersionReadable="itemVersionReadable"
                :itemDeletable="itemDeletable"
                :itemEditable="itemEditable"
                :itemLinkCheckable="itemLinkCheckable"
                :params="params"
                :isGetAll="isGetAll"
                :modelVersionName="modelVersionName"
                :hasSequence="hasSequence"
                :hasChapters="hasChapters"
                :hasCatchVersion="hasCatchVersion"
                :customParentData="customParentData"
                :expandDisable="expandDisable"
                :itemVersionReadableUrl="itemVersionReadableUrl"
                :shouldShowUpdateTag="shouldShowUpdateTag"
                @delete="$_onDelete($event)"
              ></WsDataExpandListItem>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="hasSequence">
        <WsDataExpandListItem
          v-for="(questionItem, questionIndex) in _sequenceFields"
          :key="questionIndex"
          :modelName="modelName"
          :titleKey="titleKey"
          :modeVersions="modeVersions"
          :value="questionItem"
          :modelId="questionItem.id"
          :fields="fields"
          :fieldsRead="fieldsRead"
          :locale="locale"
          :hideOnNull="hideOnNull"
          :parentModelName="parentModelName"
          :createVersion="createVersion"
          :itemVersionCreatable="itemVersionCreatable"
          :itemVersionLinkCreatable="itemVersionLinkCreatable"
          :itemVersionReadable="itemVersionReadable"
          :itemDeletable="itemDeletable"
          :itemEditable="itemEditable"
          :itemLinkCheckable="itemLinkCheckable"
          :params="params"
          :isGetAll="isGetAll"
          :modelVersionName="modelVersionName"
          :hasSequence="hasSequence"
          :hasChapters="hasChapters"
          :hasCatchVersion="hasCatchVersion"
          :customParentData="customParentData"
          :expandDisable="expandDisable"
          :itemVersionReadableUrl="itemVersionReadableUrl"
          :itemLinkEditable="itemLinkEditable"
          :customBtns="customBtns"
          :staticModelData="staticModelData"
          :customUpdateAction="customUpdateAction"
          :defaultBtnDisplayFunc="defaultBtnDisplayFunc"
          :customUpdateSubmitAction="customUpdateSubmitAction"
          :shouldShowUpdateTag="shouldShowUpdateTag"
          @delete="$_onDelete($event)"
          @update-submit="$_onUpdateSubmit($event, questionIndex)"
          @custom-event="$_onCustomEvent($event)"
        ></WsDataExpandListItem>
      </div>
      <div v-else>
        <div v-if="tabSetting">
          <WsCarousel :menuData="tabSetting" @input="$_onTabInput($event)"></WsCarousel>
        </div>
        <div v-else-if="modelDatas" class="ws-data-expand-list__title">
          {{ label }} 共 {{ _totalModel }} 筆
        </div>
        <DynamicScroller
          v-if="virtualScroll"
          keyField="id"
          :min-item-size="100"
          :items="modelDatas"
          :buffer="1100"
          page-mode
        >
          <template #default="{ item, index, active }">
            <DynamicScrollerItem
              :item="item"
              :active="active"
              :size-dependencies="$_itemSizeDeps(item)"
            >
              <div>
                <!-- 卡片間距用 padding（pb-5）而非 margin：DynamicScrollerItem 量測高度不含 margin，用 margin 會導致卡片重疊 -->
                <div class="pb-5">
                  <WsDataExpandListItem
                    :modelName="modelName"
                    :titleKey="titleKey"
                    :modeVersions="modeVersions"
                    :value="item"
                    :modelId="item.id"
                    :itemState="itemStates[item.id] || {}"
                    :fields="fields"
                    :fieldsRead="fieldsRead"
                    :locale="locale"
                    :hideOnNull="hideOnNull"
                    :parentModelName="parentModelName"
                    :createVersion="createVersion"
                    :itemVersionCreatable="itemVersionCreatable"
                    :itemVersionLinkCreatable="itemVersionLinkCreatable"
                    :itemVersionReadable="itemVersionReadable"
                    :itemDeletable="itemDeletable"
                    :itemEditable="itemEditable"
                    :itemLinkCheckable="itemLinkCheckable"
                    :params="params"
                    :isGetAll="isGetAll"
                    :modelVersionName="modelVersionName"
                    :modelData="modelData"
                    :hasSequence="hasSequence"
                    :hasChapters="hasChapters"
                    :hasCatchVersion="hasCatchVersion"
                    :customParentData="customParentData"
                    :expandDisable="expandDisable"
                    :groupSaving="groupSaving"
                    :itemVersionReadableUrl="itemVersionReadableUrl"
                    :itemLinkEditable="itemLinkEditable"
                    :customBtns="customBtns"
                    :disableSaveBtn="disableSaveBtn"
                    :staticModelData="staticModelData"
                    :customUpdateAction="customUpdateAction"
                    :defaultBtnDisplayFunc="defaultBtnDisplayFunc"
                    :customUpdateSubmitAction="customUpdateSubmitAction"
                    :shouldShowUpdateTag="shouldShowUpdateTag"
                    @state-change="$_onItemStateChange($event)"
                    @request-content="$_onRequestContent($event)"
                    @delete="$_onDelete($event)"
                    @update-submit="$_onUpdateSubmit($event, index)"
                    @groupSave="$_onGroupSave($event)"
                    @item-changed="$_onChangeItem($event)"
                    @delete-changed-item="$_onDeleteChangedItem($event)"
                    @deleteGroupSave="$_onDeleteGroupSave($event)"
                    @custom-event="$_onCustomEvent($event)"
                  ></WsDataExpandListItem>
                </div>
              </div>
            </DynamicScrollerItem>
          </template>
        </DynamicScroller>
        <template v-else>
          <WsDataExpandListItem
            v-for="(listItemData, listItemIndex) in modelDatas"
            :key="listItemData.id"
            :modelName="modelName"
            :titleKey="titleKey"
            :modeVersions="modeVersions"
            :value="listItemData"
            :modelId="listItemData.id"
            :fields="fields"
            :fieldsRead="fieldsRead"
            :locale="locale"
            :hideOnNull="hideOnNull"
            :parentModelName="parentModelName"
            :createVersion="createVersion"
            :itemVersionCreatable="itemVersionCreatable"
            :itemVersionLinkCreatable="itemVersionLinkCreatable"
            :itemVersionReadable="itemVersionReadable"
            :itemDeletable="itemDeletable"
            :itemEditable="itemEditable"
            :itemLinkCheckable="itemLinkCheckable"
            :params="params"
            :isGetAll="isGetAll"
            :modelVersionName="modelVersionName"
            :modelData="modelData"
            :hasSequence="hasSequence"
            :hasChapters="hasChapters"
            :hasCatchVersion="hasCatchVersion"
            :customParentData="customParentData"
            :expandDisable="expandDisable"
            :groupSaving="groupSaving"
            :itemVersionReadableUrl="itemVersionReadableUrl"
            :itemLinkEditable="itemLinkEditable"
            :customBtns="customBtns"
            :disableSaveBtn="disableSaveBtn"
            :staticModelData="staticModelData"
            :customUpdateAction="customUpdateAction"
            :defaultBtnDisplayFunc="defaultBtnDisplayFunc"
            :customUpdateSubmitAction="customUpdateSubmitAction"
            :shouldShowUpdateTag="shouldShowUpdateTag"
            @delete="$_onDelete($event)"
            @update-submit="$_onUpdateSubmit($event, listItemIndex)"
            @groupSave="$_onGroupSave($event)"
            @item-changed="$_onChangeItem($event)"
            @delete-changed-item="$_onDeleteChangedItem($event)"
            @deleteGroupSave="$_onDeleteGroupSave($event)"
            @custom-event="$_onCustomEvent($event)"
          ></WsDataExpandListItem>
        </template>
      </div>
    </div>
    <div v-if="fetchLoading" class="mt-5">
      <v-skeleton-loader
        v-for="n in 3"
        :key="`skeleton-${n}`"
        type="list-item-three-line"
        :tile="true"
        class="mt-5"
      ></v-skeleton-loader>
    </div>
    <div v-if="createModeActive && groupSaving">
      <WsCard v-for="(groupItem, groupIndex) in groupSaveCreateArr" :key="groupIndex">
        <ValidationObserver ref="form">
          <WsStateForm
            class="mb-3"
            :generalFields="_updateFields"
            @isCompleted="$_isFormCompleted($event, value)"
            :modelData="modelData"
            :customParentData="customParentData"
            v-model="groupSaveCreateArr[groupIndex]"
          ></WsStateForm>
        </ValidationObserver>
        <v-divider></v-divider>
        <v-card-actions class="pa-5">
          <v-spacer></v-spacer>
          <WsBtn @click="$_onCreateCancel()" minWidth="100px" color="textSecondary" outlined
            >取消</WsBtn
          >
        </v-card-actions>
      </WsCard>
    </div>
    <WsBtn v-if="groupSaving" @click="$_createMultiOpen()" color="primary" outlined>
      <v-icon left>mdi-plus</v-icon> 單筆新增{{ label }}
    </WsBtn>
  </div>
</template>

<script>
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';

export default {
  components: {
    DynamicScroller,
    DynamicScrollerItem,
  },
  data: () => ({
    searching: '',
    modelDatas: [],
    // 虛擬滾動：以 id 為 key 的 item 狀態中心（展開/編輯/內容快取），child 被回收重建時據此還原
    itemStates: {},
    // 父層代抓展開內容的去重旗標（以 id 為 key）
    contentFetching: {},
    createModeActive: false,
    createData: {},
    createSubmitLoading: false,
    fetchLoading: false,
    page: 1,
    lastPage: 10,
    totalData: 0,
    isCatching: false,
    isCreated: false,
    tabActiveName: '',
    stopFetch: false,
    groupSaveArr: [],
    groupSaveCreateArr: [],
    changedArr: [],
  }),
  methods: {
    $_onInput($event) {
      this.createData = $event;
    },
    $_onSearchSubmit() {
      this.fetchData();
    },
    $_onUpdateSubmit($event, index) {
      if ($event.custom) {
        const tarIndex = this.modelDatas.findIndex((e) => {
          return e.id == $event.id;
        });
        this.$set(this.modelDatas, [tarIndex], {
          ...this.modelDatas[tarIndex],
          ...$event,
          id: $event.newId ? $event.newId : $event.id,
          [this.titleKey]: $event.locales[this.$store.state.locale.selectingLocale][this.titleKey],
        });
      } else if ($event.isPostData) {
        const _index = this.modelDatas.findIndex((e) => {
          return e.id == $event.id;
        });
        this.$set(this.modelDatas, [_index], {
          ...this.modelDatas[_index],
          [this.titleKey]: $event.locales[this.$store.state.locale.selectingLocale][this.titleKey],
        });
      } else {
        if (this.hasSequence) {
          this.modelDatas[index].last_version = {
            ...this.modelDatas[index].last_version,
            ...$event,
          };
        } else {
          const _index = this.modelDatas.findIndex((e) => {
            return e.id == $event.id;
          });
          this.modelDatas[_index].last_version = {
            ...this.modelDatas[_index].last_version,
            ...$event,
          };
        }
      }
    },
    async $_onDelete($event) {
      const tarIndex = this.modelDatas.findIndex((e) => {
        return e.id == $event;
      });
      this.modelDatas.splice(tarIndex, 1);
      this.totalData--;
      this.$delete(this.itemStates, $event);
      this.$emit('deleted', $event);
    },
    $_onItemStateChange({ id, patch } = {}) {
      this.$set(this.itemStates, id, {
        ...(this.itemStates[id] || {}),
        ...patch,
      });
    },
    $_itemSizeDeps(item) {
      // 僅作為「無 ResizeObserver 瀏覽器」的 fallback；現代瀏覽器由 DynamicScrollerItem 的 ResizeObserver 量測
      const state = this.itemStates[item.id] || {};
      return [item.id, item[this.titleKey], state.readActive, state.updateActive];
    },
    // 父層代為抓取展開內容：以 id 去重，且不受 child 被回收重建影響 → 同一 item 只抓一次
    async $_onRequestContent({ id, modelName }) {
      if (this.itemStates[id] && this.itemStates[id].isContentLoaded) return;
      if (this.contentFetching[id]) return;
      this.$set(this.contentFetching, id, true);
      try {
        const res = await this.$axios.get(`/${modelName}/${id}`);
        const data = this.staticModelData ? this.staticModelData(res.data.data) : res.data.data;
        this.$set(this.itemStates, id, {
          ...(this.itemStates[id] || {}),
          fetchValue: data,
          isContentLoaded: true,
        });
      } catch (error) {
        alert(error);
      } finally {
        this.$delete(this.contentFetching, id);
      }
    },
    $_onCreateCancel() {
      this.createData = {};
      this.createModeActive = false;
    },
    async $_onCreateSubmit() {
      const isValidate = await this.$refs.form.validate();
      if (!isValidate) {
        return;
      }
      try {
        this.createModeActive = false;
        this.fetchLoading = true;
        this.createSubmitLoading = true;
        if (this.groupSaving) return;
        if (this.customCreateSubmitAction) {
          const data = await this.customCreateSubmitAction(this.createData);
          this.createSubmitLoading = false;
          this.fetchLoading = false;
          this.modelDatas.push(data);
        } else if (this.hasSequence) {
          let postData = JSON.parse(JSON.stringify(this.createData.last_version));
          //新增題目
          let newData = {};
          newData = JSON.parse(JSON.stringify(this.params));
          newData = {
            ...newData,
            [`${this.parentModelName}s`]: [newData[`${this.parentModelName}s`]],
            [`${this.rootModelName}s`]: [newData[`${this.rootModelName}s`]],
          };
          try {
            const res = await this.$axios.post(`/${this.modelName}`, newData);
            try {
              //新增題目版本
              //綁新題目
              //this.modelName
              postData[`${this.modelName}`] = res.data.data.id;
              //綁原本公版版本
              postData = {
                ...postData,
                ...this.postData,
                [`${this.parentModelName}s`]: [this.postData[`${this.parentModelName}s`]],
                [`${this.rootModelName}s`]: [this.postData[`${this.rootModelName}s`]],
              };
              //題目版本的 status
              if (this.customParentData && this.customParentData.version_status) {
                postData.status = 1;
              } else {
                postData.status = 0;
              }
              if (this.customCreateAction) postData = this.customCreateAction(postData);
              const versionRes = await this.$axios.post(`/${this.modelVersionName}`, postData);
              //更新顯示題目資料
              let newObj = {};
              newObj.id = res.data.data.id;
              newObj.last_version = versionRes.data.data;
              this.modelDatas.push(newObj);
              this.$emit('created', res.data.data);
              try {
                this.createSubmitLoading = false;
                this.fetchLoading = false;
              } catch (error) {
                alert(error, '新增題目錯誤');
                this.createSubmitLoading = false;
              }
            } catch (error) {
              alert(error, '新增題目版本錯誤');
              this.createSubmitLoading = false;
            }
          } catch (error) {
            alert(error, '更新公版題目錯誤');
            this.createSubmitLoading = false;
          }
        } else if (this.isVersionAPI) {
          const postUrl = `${this.parentModelName}/${this.parentState}/article`;
          let postData = JSON.parse(JSON.stringify(this.createData));
          const res = await this.$axios.post(postUrl, postData);
          try {
            postData.article = res.data.data.id;
            postData[this.parentModelName] = this.parentState;
            postData = {
              ...postData,
              [`${this.parentModelName}s`]: [this.parentState],
            };
            const VersionDataRes = await this.$axios.post(`${this.modelName}`, postData);
            this.createSubmitLoading = false;
            this.fetchLoading = false;
            this.modelDatas.push(VersionDataRes.data.data);
          } catch (error) {
            alert(error);
          }
        } else {
          const postUrl =
            this.parentState && this.parentModelName
              ? `/${this.parentModelName}/${this.parentState}/${this.modelName}`
              : `/${this.modelName}`;
          let postData = JSON.parse(JSON.stringify(this.createData));
          if (this.customCreateAction) postData = this.customCreateAction(postData);
          const res = await this.$axios.post(postUrl, postData);
          if (this.modeVersions) {
            try {
              await this.$axios.post(
                `/${this.modelName}/${res.data.data.id}/${this._versionModelName}`,
                this.createData.last_version,
              );
              this.createSubmitLoading = false;
              //更新local題目資料
              await this.fetchData();
            } catch (error) {
              alert('新增錯誤');
              this.createSubmitLoading = false;
            } finally {
              this.fetchLoading = false;
            }
          } else {
            this.createSubmitLoading = false;
            this.fetchLoading = false;
            this.page = 1;
            if (this.stopFetch) this.stopFetch = false;
            await this.fetchData();
          }
        }
      } catch (error) {
        alert('新增錯誤');
        this.createSubmitLoading = false;
      }
    },
    $_createOpen() {
      this.$_CMS_updateDataSetFromFields(this, this.createData, this.fields);
      this.createModeActive = true;
    },
    $_createMultiOpen() {
      this.groupSaveCreateArr.push({});
      this.$_CMS_updateDataSetFromFields(
        this,
        this.groupSaveCreateArr[this.groupSaveCreateArr.length - 1],
        this.fields,
      );
      this.createModeActive = true;
    },
    $_multiSelectOpen() {
      this.$refs.multiSelectDialog.open();
    },
    async fetchData() {
      if (this.isCatching || this.stopFetch) {
        return;
      }
      if (this.isGetAll) {
        this.stopFetch = true;
      }
      if (this.page > this.lastPage) {
        return;
      }
      this.fetchLoading = true;
      this.isCatching = true;
      try {
        let res = {};
        let getUrl;
        if (this.getUrl) {
          getUrl = this.getUrl();
        } else if (
          this.parentState &&
          this.parentModelName &&
          !this.hasChapters &&
          !this.hasSequence &&
          !this.hasCatchVersion &&
          !this.isVersionAPI &&
          !this.groupSaving
        ) {
          getUrl = `/${this.parentModelName}/${this.parentState}/${this.modelName}`;
        } else {
          getUrl = `/${this.modelName}`;
        }
        let params = {
          search: this.searching,
          lang: this.locale,
          order_by: this.orderBy,
          order_way: this.orderWay,
          page: this.page,
          ...this.params,
        };
        res = await this.$axios.get(getUrl, {
          params: params,
        });
        if (this.modelDatas.length > 1) {
          for (let resItem of res.data.data) {
            if (this.modelDatas.find((item) => item.id === resItem.id)) {
              continue;
            } else {
              this.modelDatas.push(resItem);
            }
          }
        } else {
          this.modelDatas = [...res.data.data];
        }
        this.$emit('fetch', this.modelDatas);
        if (res.data.meta) {
          this.page = res.data.meta.current_page;
          this.lastPage = res.data.meta.last_page;
          this.totalData = res.data.meta.total;
        }
        this.page++;
      } catch (error) {
        alert(error);
      } finally {
        this.fetchLoading = false;
        this.isCatching = false;
      }
    },
    $_scrollHandle(e) {
      if (!this.$refs.infiniteList) return;
      const scrollElm = e.target.scrollingElement;
      const listElm = this.$refs.infiniteList.getBoundingClientRect();
      if (
        listElm.height < window.innerHeight ||
        scrollElm.scrollTop + scrollElm.clientHeight >= scrollElm.scrollHeight - 100
      ) {
        this.fetchData();
      }
    },
    $_onTabInput($event) {
      this.modelName = $event[0];
      this.tabActiveName = $event[1];
      this.fetchData();
    },
    $_getConditions(fieldKey) {
      const _conditions = [];
      const conditionKeys = this.$_getFieldAttr(fieldKey, 'conditionKeys');
      if (!conditionKeys) {
        return [];
      }
      conditionKeys.forEach((conditionKey) => {
        _conditions.push({
          key: conditionKey.conditionName,
          value: this.value[conditionKey.fieldName],
          type: conditionKey.type,
        });
      });
      return _conditions;
    },
    $_fixedButtonVisible() {
      if (!this.$refs.titleButton) return;
      let titleButton = this.$refs.titleButton.getBoundingClientRect();
      let titleButtonPosition = titleButton.y + titleButton.height;
      if (this.position.scrollTop > titleButtonPosition) {
        this.fixedButtonActive = true;
      } else {
        this.fixedButtonActive = false;
      }
    },
    $_onGroupSave($event) {
      if (this.groupSaveArr.length === 0) {
        this.groupSaveArr.push($event);
      } else {
        let index = this.groupSaveArr.findIndex((e) => {
          return e.id === $event.id;
        });
        if (index === -1) {
          this.groupSaveArr.push($event);
        } else {
          this.groupSaveArr[index] = { ...this.groupSaveArr[index], ...$event };
        }
      }
    },
    $_onChangeItem($event) {
      if (this.changedArr.length === 0) {
        this.changedArr.push($event);
      } else {
        const index = this.changedArr.findIndex((e) => e.id === $event.id);
        if (index < 0) this.changedArr.push($event);
        else this.changedArr[index] = { ...this.changedArr[index], ...$event };
      }
      this.$emit('item-changed', this.changedArr);
    },
    $_onDeleteGroupSave($event) {
      let index = this.groupSaveArr.findIndex((e) => {
        return e.id === $event;
      });
      if (index !== -1) {
        this.groupSaveArr.splice(index, 1);
      }
    },
    $_onDeleteChangedItem($event) {
      const index = this.changedArr.findIndex((e) => e.id === $event);
      if (index >= 0) {
        this.changedArr.splice(index, 1);
        this.$emit('item-changed', this.changedArr);
      }
    },
    async $_groupSaveSubmit() {
      if (!this.groupSaving) return;
      try {
        const newArr = [];
        //新增法條
        this.groupSaveCreateArr.forEach((item) => {
          newArr.push(
            this.$axios.post(
              `/${this.parentModelName}/${
                this.modelData.last_version
                  ? this.modelData.last_version.id
                    ? this.modelData.last_version.id
                    : this.postData[this.parentModelName]
                  : this.postData[this.parentModelName]
              }/article`,
              item,
            ),
          );
        });
        const newDataRes = await Promise.all(newArr);
        try {
          ///
          //更新現有法條版本
          const newVersionArr = [];
          if (this.groupSaveArr.length) {
            this.groupSaveArr.forEach((item) => {
              item[`${this.parentModelName}`] = this.postData[this.parentModelName];
              item.article = item.article.id;
              if (this.modelData.last_version && this.modelData.last_version.version_status === 0) {
                newVersionArr.push(this.$axios.post(`/${this.modelName}/unrelease`, item));
              } else {
                newVersionArr.push(this.$axios.post(`/${this.modelName}`, item));
              }
            });
          }
          //新增法條版本
          if (this.groupSaveCreateArr.length) {
            this.groupSaveCreateArr.forEach((item, index) => {
              item[`${this.parentModelName}`] = this.modelData.last_version
                ? this.modelData.last_version.id
                  ? this.modelData.last_version.id
                  : this.postData[this.parentModelName]
                : this.postData[this.parentModelName];
              item.article = newDataRes[index].data.data.id;
              if (this.modelData.last_version && this.modelData.last_version.version_status === 0) {
                newVersionArr.push(this.$axios.post(`/${this.modelName}/unrelease`, item));
              } else {
                newVersionArr.push(this.$axios.post(`/${this.modelName}`, item));
              }
            });
          }
          const res = await Promise.all(newVersionArr);
          //emit 原本的題目
          if (this.customSubmitModelDatasAction)
            this.modelDatas = this.customSubmitModelDatasAction(this.modelDatas);
          let newModelDatas = this.modelDatas
            .filter((filterItem) => {
              return !this.groupSaveArr.find((findItem) => {
                return filterItem.id === findItem.id;
              });
            })
            .map((mapItem) => {
              return mapItem.id;
            });
          if (res) {
            res.forEach((item) => {
              if (newModelDatas.findIndex((modelDataId) => modelDataId == item.data.data.id) < 0) {
                newModelDatas.push(item.data.data.id);
              }
            });
          }
          if (newModelDatas) {
            this.$emit('groupSave', newModelDatas);
          }
        } catch (error) {
          alert(error);
        }
      } catch (error) {
        alert(error);
      }
    },
    $_createBtnClickEmit() {
      this.$emit('create-btn-click');
    },
    $_onCustomEvent($event) {
      if ($event.customFunction) $event.customFunction(this.modelDatas, $event);
      this.$emit('custom-event', $event);
    },
  },
  computed: {
    _sequenceFields() {
      let newArr = [];
      if (this.hasSequence) {
        newArr = this.modelDatas;
      } else if (this.hasChapters) {
        if (!this.sequenceFields || this.modelDatas.length === 0) return;
        newArr = JSON.parse(JSON.stringify(this.sequenceFields));
        this.sequenceFields.forEach((chapterItem, chapterIndex) => {
          chapterItem.sections.forEach((sectionItem, sectionIndex) => {
            sectionItem.topics.forEach((topicItem, topicIndex) => {
              let index = this.modelDatas.findIndex((e) => {
                return e.id == topicItem.id;
              });
              newArr[chapterIndex].sections[sectionIndex].topics[topicIndex] =
                this.modelDatas[index];
            });
          });
        });
      }

      return newArr;
    },
    _updateData() {
      let _updateData = JSON.parse(JSON.stringify(this.modelData));
      this.$_CMS_updateDataSetFromFields(this, _updateData, this.fields);
      return _updateData;
    },
    _updateFields() {
      return this.$_CMS_geUpdateFields(this.fields);
    },
    _batchLink() {
      if (this.batchLink) {
        const data = { ...this.modelData, version_id: this.parentState ? this.parentState : null };
        return this.batchLink(data);
      } else if (this.parentModelName && this.parentState) {
        return `/${this.parentModelName}/${this.parentState}/${this.modelName}/create/batch`;
      } else {
        return `/${this.modelName}/create/batch`;
      }
    },
    _versionModelName() {
      return `${this.modelName}_version`;
    },
    _totalModel() {
      if (this.totalData > 0) {
        return this.totalData;
      } else {
        return this.modelDatas.length;
      }
    },
    _editPath() {
      return this.$route.path.includes('version')
        ? `/${this.params.modelName}/${this.$route.params.id}/add_chapter/${
            this.params[`${this.parentModelName}s`]
          }`
        : `${this.$route.path}/add_chapter/${this.params[`${this.versionModelName}`]}`;
    },
    _batchCreateMultiLangLink() {
      if (this.batchCreateMultiLangLink) {
        const data = { ...this.modelData, version_id: this.parentState ? this.parentState : null };
        return this.batchCreateMultiLangLink(data);
      } else if (this.parentModelName && this.parentState) {
        return `/${this.parentModelName}/${this.parentState}/${this.modelName}/create/batch-multi-lang`;
      } else {
        return `/${this.modelName}/create/batch-multi-lang`;
      }
    },
  },
  watch: {
    position() {
      this.$_fixedButtonVisible();
    },
    params: {
      handler() {
        if (this.params && this.fetchWithParams) {
          this.page = 1;
          this.modelDatas = [];
          this.fetchData();
        }
      },
    },
    changedArr: {
      handler() {
        this.$emit('item-changed', this.changedArr);
      },
      deep: true,
    },
  },
  props: {
    modeVersions: {
      type: Boolean,
      default: false,
    },
    batchMode: {
      type: Boolean,
      default: false,
    },
    searchMode: {
      type: Boolean,
      default: false,
    },
    locale: {
      type: String,
      default: null,
    },
    titleKey: {
      type: String,
      default: null,
    },
    modelName: {
      type: String,
      default: null,
    },
    modelTemplateName: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: null,
    },
    parentModelName: {
      type: String,
      default: null,
    },
    parentState: {},
    fields: {
      type: Object,
      default: null,
    },
    fieldsRead: {
      type: Array,
      default: null,
    },
    orderBy: {
      type: String,
      default: 'sequence',
    },
    orderWay: {
      type: String,
      default: 'asc',
    },
    subVersionFields: {
      type: Object,
      default() {
        return {};
      },
    },
    subVersionFieldsReads: {
      type: Array,
      default() {
        return [];
      },
    },
    rootModelName: {
      type: String,
      default: '',
    },
    hideOnNull: {
      type: Boolean,
      default: true,
    },
    filterSelects: {
      type: Array,
      default: null,
    },
    isMultiSelect: {
      type: Boolean,
      default: false,
    },
    showExpand: {
      type: Boolean,
      default: true,
    },
    showFields: {
      type: Array,
    },
    tabSetting: {
      type: Array,
    },
    multiTomulti: {
      type: Boolean,
      default: false,
    },
    createVersion: {
      type: Boolean,
      default: false,
    },
    modelData: {
      type: Object,
      default() {
        return {};
      },
    },
    itemVersionCreatable: {
      type: Boolean,
    },
    itemVersionLinkCreatable: {
      type: Boolean,
    },
    itemVersionReadable: {
      type: Boolean,
    },
    itemEditable: {
      type: Boolean,
    },
    itemDeletable: {
      type: Boolean,
    },
    itemLinkCheckable: {
      type: Boolean,
    },
    params: {
      type: Object,
    },
    sequenceFields: {
      type: Array,
    },
    postData: {
      type: Object,
    },
    isGetAll: {
      type: Boolean,
      default: false,
    },
    modelVersionName: {
      type: String,
      default: '',
    },
    hasSequence: {
      type: Boolean,
      default: false,
    },
    hasChapters: {
      type: Boolean,
      default: false,
    },
    hasCatchVersion: {
      type: Boolean,
      default: false,
    },
    customParentData: {
      type: Object,
    },
    expandDisable: {
      type: Boolean,
      default: false,
    },
    groupSaving: {
      type: Boolean,
    },
    articleSaving: {
      type: Boolean,
      default: false,
    },
    isVersionAPI: {
      type: Boolean,
      defalult: false,
    },
    itemVersionReadableUrl: {
      type: Function,
    },
    fetchWithParams: {
      type: Boolean,
    },
    batchLink: {
      type: Function,
    },
    itemLinkEditable: {
      type: Boolean,
    },
    itemCreateBtnEmitAble: {
      type: Boolean,
      default: false,
    },
    customBtns: {
      type: Array,
      default() {
        return [];
      },
    },
    versionModelName: {
      type: String,
      default: '',
    },
    getUrl: {
      type: Function,
    },
    disableSaveBtn: {
      type: Boolean,
      default: false,
    },
    customSubmitModelDatasAction: {
      type: Function,
    },
    staticModelData: {
      type: Function,
    },
    customCreateAction: {
      type: Function,
    },
    customUpdateAction: {
      type: Function,
    },
    defaultBtnDisplayFunc: {
      type: Function,
    },
    customUpdateSubmitAction: {
      type: Function,
    },
    customCreateSubmitAction: {
      type: Function,
    },
    itemCreatable: {
      type: Boolean,
      default: true,
    },
    shouldShowUpdateTag: {
      type: Function,
    },
    isBatchCreateMultiLangAble: {
      type: Boolean,
      default: false,
    },
    batchCreateMultiLangLink: {
      type: Function,
    },
    virtualScroll: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    window.addEventListener('scroll', this.$_scrollHandle);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.$_scrollHandle);
  },
  mounted() {
    this.fetchData();
    this.$_CMS_updateDataSetFromFields(this, this.createData, this.fields);
  },
};
</script>

<style lang="scss">
@import '../assets/scss/ws-data-expand-list.scss';
</style>
